module.exports = __webpack_public_path__ + "img/articleAddictions.892143ff.png";